module.exports = __webpack_public_path__ + "static/img/cw-5.15f03f2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/cw-5.jpg
 ** module id = 579
 ** module chunks = 2
 **/